import React from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tab,
    Tabs,
    Tooltip,
    DialogActions,
    Button,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import TabPanel from "../../Component/TabPanel/TabPanel";
import AddReferralBonusCredits from "./AddReferralBonusCredits";
import { SlideUpTransition } from "../../Component/Reusables/Transitions";
import CreateCurrencyPairRules from "./CreateCurrencyPairRules";

// Interface for ReferralSettings props
interface ReferralSettingsProps {
    open: boolean;
    onClose?: (state: boolean, action: string) => void;
    accessToken: string;
    isSaveSettingsAllowed: boolean;
}

// Interface for ReferralSettings state
interface ReferralSettingsState {
    tabValue: number;
    hasErrors: boolean;
    isLimitConfirm: boolean;
}

class ReferralSettings extends React.Component<ReferralSettingsProps, ReferralSettingsState> {
    // Refs for child components
    private addReferralBonusCreditsRef = React.createRef<AddReferralBonusCredits>();
    private createCurrencyPairRulesRef = React.createRef<CreateCurrencyPairRules>();

    constructor(props: ReferralSettingsProps) {
        super(props);
        this.state = {
            tabValue: 0,
            isLimitConfirm: false,
            hasErrors: false
        };
    }

    // Tab change handler
    handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        this.setState({ tabValue: newValue });
    };

    // Close the dialog
    handleClose = (action: string) => {
        this.props.onClose?.(false, action);
    };

    //On save click
    handleSave = () => {
        if (this.state.tabValue === 0 && this.addReferralBonusCreditsRef.current) {
            console.log("Updating create rules...");

            this.addReferralBonusCreditsRef.current.setState((prevState) => ({
                ...prevState,
                isSaveConfirmationDialogOpen: true,
            }));
        } else if (this.state.tabValue === 1 && this.createCurrencyPairRulesRef.current) {
            console.log("Updating currency pair exchange rates...");

            this.createCurrencyPairRulesRef.current.setState((prevState) => ({
                ...prevState,
                isSaveConfirmationDialogOpen: true,
            }));
        }
    };

    // On save button click, check if there are any validation errors
    handleValidationChange = (hasErrors: boolean) => {
        console.log("Validation Status: ", hasErrors);
        this.setState({ hasErrors });
    };

    goToTab = (index: number) => {
        this.setState({ tabValue: index });
    };

    render() {
        const { tabValue, hasErrors } = this.state;
        const { open } = this.props;

        return (
            <Dialog
                TransitionComponent={SlideUpTransition}
                open={open}
                onClose={() => this.handleClose("cancel")}
                fullWidth
                keepMounted
                maxWidth="lg"
            >
                <DialogTitle sx={{ m: "12px 12px 0 12px", p: 2, position: "relative" }}>
                    <Tabs
                        value={tabValue}
                        onChange={this.handleTabChange}
                        aria-label="settings tabs"
                        indicatorColor="secondary"
                        textColor="primary"
                        sx={{ borderBottom: 1, borderColor: "divider" }}
                    >
                        {/* <Tab label="Currency pair and exchange rate" /> */}
                        <Tab label="Referral bonus Credits" />
                        <Tab label="Create currency pair Rules" />
                    </Tabs>
                    <Tooltip title="Close">
                        <IconButton
                            aria-label="close"
                            onClick={() => this.handleClose("cancel")}
                            sx={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                color: (theme) => theme.palette.grey[600],
                            }}
                        >
                            <Close />
                        </IconButton>
                    </Tooltip>
                </DialogTitle>
                <DialogContent className="subMenuModal">
                    <TabPanel value={tabValue} index={0}>
                        <AddReferralBonusCredits
                            ref={this.addReferralBonusCreditsRef}
                            open={tabValue === 0}
                            onValidationChange={this.handleValidationChange}
                            accessToken={this.props.accessToken}
                            isSaveSettingsAllowed={true}
                            onClose={(state: boolean, action: string) => {
                                this.handleClose(action);
                            }}
                            goToTab={this.goToTab} 
                        />
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <CreateCurrencyPairRules
                            ref={this.createCurrencyPairRulesRef}
                            open={tabValue === 0}
                            onValidationChange={this.handleValidationChange}
                            accessToken={this.props.accessToken}
                            isSaveSettingsAllowed={true}
                            onClose={(state: boolean, action: string) => {
                                this.handleClose(action);
                            }}
                            goToTab={this.goToTab} 
                        />
                    </TabPanel>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleClose("cancel")}>Cancel</Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={this.handleSave}
                        disabled={hasErrors || !this.props.isSaveSettingsAllowed}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ReferralSettings;